import { useFocusTimer } from "./FocusTimerProvider";
import "./FocusTimer.css";

function FloatingTimerBubble() {
  const { timer, toggleMinimize } = useFocusTimer();

  const minutes = Math.floor(timer.remaining / 60)
    .toString()
    .padStart(2, "0");

  const seconds = (timer.remaining % 60)
    .toString()
    .padStart(2, "0");

  return (
    <div
      className={`timer-bubble ${
        timer.isRunning ? "running" : ""
      } ${!timer.isMinimized ? "hidden" : ""}`}
      onClick={toggleMinimize}
    >
      <div className="bubble-content">
        <span className="bubble-time">
          {minutes}:{seconds}
        </span>
      </div>
    </div>
  );
}

export default FloatingTimerBubble;